import { Grid, Group } from "@mantine/core"
import { AgencyOperationsAdminBookingTabs } from "src/components/agency/operations/administrator/bookings/AgencyOperationsAdminBookingTabs"
import { EditAgencyOperationsAdminBookingAction } from "src/components/agency/operations/administrator/bookings/AgencyOperationsAdminBookingActions"
import { useAppState } from "src/state"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { formatDate, formatTime } from "src/utils/dates"
import { AgencyOperationsAdminBookingView } from "src/components/agency/operations/administrator/bookings/AgencyOperationsAdminBookingView"
import { BookingStatusMachine } from "src/components/bookings"
import { AgencyOperationsAdminBookingGuidelineActions } from "src/components/agency/operations/administrator/bookings/guidelines/AgencyOperationsAdminBookingGuidelineActions"

export function AgencyOperationsAdminBookingOverlay() {

    const { currentItem } = useAppState(state => state.bookings)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.talent_id ? currentItem.talent?.dj_display : 'Unassigned'} @ ${currentItem?.venue?.name}, ${formatDate(currentItem?.date, 'M/d')} ${!!currentItem?.set_start_time ? '- ' : ''}${formatTime(currentItem?.set_start_time)}`}
                    renderAction={
                        <Group gap="sm">
                            <EditAgencyOperationsAdminBookingAction />
                        </Group>
                    }
                />
            }
        >
            <AgencyOperationsAdminBookingTabs overlay={true} />

            <Grid>
                <Grid.Col span={{ base: 12, md: 4 }}>
                    <BookingStatusMachine
                        showStatusBadge={true}
                        showDescriptions={true}
                        buttonSize="xs"
                        spacing="md"
                    />
                    <AgencyOperationsAdminBookingGuidelineActions />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 8 }}>
                    <AgencyOperationsAdminBookingView />
                </Grid.Col>
            </Grid>

        </DrawerPageLayout>
    )

}